import React, { useState, useEffect } from 'react';
import { addFavoriteContractor, removeFavoriteContractor } from '../api/userFavoriteContractor';

interface FavoriteButtonProps {
  contractorId: number;
  initialIsFavorited: boolean;
  onToggleFavorite: (contractorId: number, isFavorited: boolean) => void;
}

const FavoriteButton: React.FC<FavoriteButtonProps> = ({ contractorId, initialIsFavorited, onToggleFavorite }) => {
  const [isFavorited, setIsFavorited] = useState<boolean>(initialIsFavorited);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setIsFavorited(initialIsFavorited);
  }, [initialIsFavorited]);

  const handleToggleFavorite = async () => {
    setIsLoading(true);
    setError(null);
    try {
      
      if (isFavorited) {
        await removeFavoriteContractor(contractorId);
        setIsFavorited(false);
        onToggleFavorite(contractorId, false);
      } else {
        await addFavoriteContractor(contractorId);
        setIsFavorited(true);
        onToggleFavorite(contractorId, true);
      }
    } catch (err) {
      console.error('Failed to toggle favorite status:', err);
      setError('Failed to update favorite status.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleToggleFavorite}
      disabled={isLoading}
      className={`px-4 py-2 rounded-md text-white ${isFavorited ? 'bg-red-500 hover:bg-red-600' : 'bg-blue-500 hover:bg-blue-600'} disabled:opacity-50`}
    >
      {isLoading ? 'Updating...' : isFavorited ? 'Unfavorite' : 'Favorite'}
      {error && <p className="text-red-700 text-sm mt-1">{error}</p>}
    </button>
  );
};

export default FavoriteButton;